import React, { useEffect, useRef } from 'react';
import s from './NewAbout.module.css';

import portrait from '../images/שובל רוימי תדמית 5.webp';

export default function NewAbout() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      // Immediately reveal if reduced motion is preferred
      sectionRef.current?.classList.add(s.sectionVisible);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(s.sectionVisible);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );

    const el = sectionRef.current;
    if (el) observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return (
    <section className={s.section} ref={sectionRef}>
      {/* Atmospheric effects */}
      <div className={s.glow1} aria-hidden="true" />
      <div className={s.glow2} aria-hidden="true" />
      <div className={s.grain} aria-hidden="true" />

      <div className={s.grid}>
        {/* ---- Text Column (RIGHT in RTL) ---- */}
        <div className={s.textCol}>
          <span className={s.eyebrow}>&mdash; הסיפור מאחורי הסטודיו &mdash;</span>

          <h2 className={s.title}>
            בית שמרגיש{' '}
            <span className={s.titleEmphasis}>שלכם</span>
            , לא כמו קטלוג.
          </h2>

          <p className={s.paragraph}>
            מאז שאני זוכרת את עצמי, נכנסתי לחדר וידעתי מה צריך לשנות.
            הייתי מסדרת את הבית של ההורים שלי, מעבירה רהיטים, משנה תמונות.
            לא כי ביקשו - כי ראיתי מה אפשר.
          </p>

          <p className={s.paragraph}>
            היום, אחרי חמש שנים בתחום ועבודה במשרד שמתכנן עשרות פרויקטים
            יזמיים ופרטיים, הקמתי את סטודיו SRA כדי לעשות את הדבר שאני
            הכי מאמינה בו - לקחת תהליך מורכב ומבלבל ולהפוך אותו לפשוט,
            ברור ומדויק.
          </p>

          <p className={s.paragraph}>
            אני מגיעה לכל פרויקט כדי להגשים את החלום של הלקוח. לא את
            הטרנד של השנה, לא את מה שראיתם בפינטרסט - את מה שמתאים לכם,
            לחיים שלכם, לתקציב שלכם.
          </p>

          <blockquote className={s.pullQuote}>
            &ldquo;אני חיה את השליחות שלי - לגרום לבית להיות גם יפה
            וגם פרקטי.&rdquo;
          </blockquote>
        </div>

        {/* ---- Portrait Column (LEFT in RTL) ---- */}
        <div className={s.portraitCol}>
          <div className={s.portraitFrame}>
            <img
              className={s.portraitImage}
              src={portrait}
              alt="שובל רוימי אביסרור - אדריכלית ומעצבת פנים"
              loading="lazy"
              decoding="async"
            />
            <div className={s.glassOverlay}>
              <p className={s.glassName}>שובל רוימי אביסרור</p>
              <p className={s.glassRole}>
                אדריכלית ומעצבת פנים &middot; מייסדת סטודיו SRA
              </p>
            </div>
          </div>

          <div className={s.location}>
            <span className={s.locationLine} aria-hidden="true" />
            <span>באר שבע &middot; ישראל</span>
          </div>
        </div>
      </div>
    </section>
  );
}
